export default {
    HOME_STATE: 'HOME_STATE',
    ALL_BUTTONS_DISABLED_STATE: 'ALL_BUTTONS_DISABLED_STATE',
    TOOLBAR_ENABLED_STATE: 'TOOLBAR_ENABLED_STATE',
};
